import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "user",
    serviceName: "auth",
    query: gql`
      query {
        user {
          email
          gender
          lastname
          firstname
          birth_date
          national_code
        }
      }
    `,
  },
  update: {
    name: "updateUserSelf",
    serviceName: "auth",
    query: gql`
      mutation updateUserSelf(
        $gender: Int
        $email: String
        $lastname: String
        $firstname: String
        $birth_date: String
        $national_code: String
      ) {
        updateUserSelf(
          email: $email
          gender: $gender
          lastname: $lastname
          firstname: $firstname
          birth_date: $birth_date
          national_code: $national_code
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
